<template>
  <div style="background: #475CC7;">
    <v-container>
      <v-row class="ma-0">
        <v-col cols="12" sm="7" class="white--text">
          <v-col style="font-size: 18px;line-height: 25px;">
            Eblity Workshop | Online Event
          </v-col>
          <v-col class="workshop-heading">{{ workshopDetails.title }}</v-col>
          <v-col class="workshop-sub-heading pt-0">
            {{ workshopDetails.sub_heading }}
          </v-col>
          <v-col>
            <v-row class="ma-0" v-if="isEducatorDetailsPresent">
              <v-img
                aspect-ratio="1"
                max-width="42px"
                max-height="42px"
                style="border-radius: 50%;"
                :src="workshopDetails.speaker_image"
              />
              <v-col class="speaker-intro pt-0">
                <div>
                  by
                  {{ workshopDetails.conductor_details.user_details.name }}
                </div>
                <div>{{ workshopDetails.speaker_designation }}</div>
              </v-col>
            </v-row>
          </v-col>
          <v-row class="ma-0 mt-12">
            <v-col
              cols="12"
              sm="6"
              v-if="workshopDetails.status == 'Scheduled'"
            >
              <v-row>
                <!-- <v-col   class="px-0"> </v-col> -->
                <div align="center" style="min-width:96px" class="calender">
                  <div class="month">
                    {{ month }}
                  </div>
                  <div
                    class="black--text pa-2"
                    style="background: #FFFFFF;border-radius: 0px 0px 4px 4px;"
                  >
                    <div class="date">
                      {{ date }}
                    </div>
                    <div class="day">
                      {{ day }}
                    </div>
                  </div>
                </div>
                <v-col align-self="center" class="time pa-0 ps-2">
                  {{ time }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" class="mt-8 mt-sm-0">
              <v-row>
                <v-img
                  contain
                  max-width="72px"
                  src="@/assets/workshop/Certificate-White.svg"
                />
                <v-col class="pt-1">
                  <div
                    style="font-weight: 900;font-size: 16px;line-height: 22px;"
                  >
                    Certificate
                  </div>
                  <div style="font-size: 14px;line-height: 19px;">
                    We offer E-certificate of participation to all those who
                    attend our live sessions.
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="5">
          <EnrolmentCard
            v-if="$store.state.isMembershipEnabled"
            :workshopDetails="workshopDetails"
          />

          <RegisterLoginCard
            v-else
            :sessionDetails="sessionDetails"
            :sessionObject="workshopDetails"
          />
        </v-col>
      </v-row>
    </v-container>
    <UpcomingEventsPopup
      :events="$store.state.sessionSeriesDetails.nextEvents"
    />
  </div>
</template>

<script>
  import EnrolmentCard from "./component/EnrolmentCard.vue";
  import UpcomingEventsPopup from "./component/UpcomingEventsPopup.vue";
  import RegisterLoginCard from "../../../../../components/LoginRegister/RegisterLoginCard.vue";

  import helper from "../../../../../helper";

  export default {
    name: "HeroSection",
    props: ["workshopDetails"],
    components: {
      EnrolmentCard,
      UpcomingEventsPopup,
      RegisterLoginCard,
    },
    data() {
      return {
        date: helper.getOnlyDate(this.workshopDetails.start_date_time),
        month: helper.getDateMonth(this.workshopDetails.start_date_time, true),
        day: helper.getDay(this.workshopDetails.start_date_time),
        time:
          helper.formatTime(new Date(this.workshopDetails.start_date_time)) +
          " " +
          helper.getTimezoneName(
            new Date(this.workshopDetails.start_date_time),
            true
          ),
      };
    },
    created() {},
    computed: {
      isEducatorDetailsPresent() {
        if (this.workshopDetails.conductor_details.user_details) {
          return true;
        } else {
          return false;
        }
      },
      sessionDetails() {
        return {
          id: this.workshopDetails.id,
          headerImage: this.workshopDetails.thumbnail_path,
          title: this.workshopDetails.title,
          subTitle: this.workshopDetails.sub_heading,
          take_away: this.workshopDetails.take_aways,
          speaker_details: {
            educatorName: this.workshopDetails.conductor_details.user_details
              ? this.workshopDetails.conductor_details.user_details.name
              : "",
            educatorImage: this.workshopDetails.speaker_image
              ? this.workshopDetails.speaker_image
              : "",
            educatorBio: this.workshopDetails.speaker_bio
              ? this.workshopDetails.speaker_bio
              : "",
          },
          skills: this.workshopDetails.skills,
          ageGroup: this.workshopDetails.age_groups,
          tags: this.workshopDetails.tags,
          price: this.workshopDetails.amount,
          is_free: this.workshopDetails.is_free,
          hostedBy: this.workshopDetails.conductor_details.user_details
            ? this.workshopDetails.conductor_details.user_details.name
            : "",
          status: this.workshopDetails.status, //On Demand, Scheduled, Published
          sessions: this.workshopDetails.session_list,
          is_bought: this.workshopDetails.is_bought,
          is_requested: this.workshopDetails.is_requested,
          speaker_designation: this.workshopDetails.speaker_designation,
        };
      },
    },
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped>
  .calender > .month {
    background: #333333;
    border-radius: 4px 4px 0px 0px;
    font-weight: 800;
    font-size: 12px;
  }
  .calender > .date {
    font-weight: 900;
    font-size: 24px;
  }
  .calender > .day {
    font-weight: 500;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.7);
  }

  .time {
    font-weight: 900;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
  }

  .speaker-intro {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
  }

  .workshop-heading {
    font-weight: 800;
    font-size: 30px;
    line-height: 41px;
  }

  .workshop-sub-heading {
    font-weight: 900;
    font-size: 20px;
    line-height: 27px;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  }
</style>
